<template>
  <div v-if="cashoutMethod">
    <cashout-method-details
      :data-cashout-method.sync="cashoutMethod"
      @update:dataCashoutMethod="updatecashoutMethod"
    />
  </div>
</template>

<script>
import CashoutMethodDetails from "./details";

export default {
  props: {
    id: {
      required: true,
    },
  },
  components: { CashoutMethodDetails },
  data: () => ({
    cashoutMethod: null,
  }),
  mounted() {
    this.fetchcashoutMethod();
  },
  watch: {
    id() {
      this.fetchcashoutMethod();
    },
  },
  methods: {
    fetchcashoutMethod() {
      this.$http
        .get(`/api/v1/transactions/cryptoCashoutMethods/${this.id}`)
        .then((cashoutMethod) => (this.cashoutMethod = cashoutMethod));
    },
    updatecashoutMethod(cashoutMethod) {
      if (cashoutMethod) {
        this.cashoutMethod = cashoutMethod;
      }
    },
  },
};
</script>

<style></style>
